import { Collapse } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

import CancelButton from "../provider-management/components/buttons/CancelButton";
import LeftNavigation from "../provider-management/components/buttons/LeftNavigation";
import RightNavigation from "../provider-management/components/buttons/RightNavigation";
import SaveButton from "../provider-management/components/buttons/SaveButton";
import STRINGS from "../provider-management/utils/strings";

import useProviderDetailServicesSection from "./hooks/useProviderDetailServicesSection";
import ServicesPanel from "./sections/services/ServicesPanel";
import ProviderDetailSectionCard from "./sections/shared/ProviderDetailSectionCard";
import ProviderDetailSectionTitle from "./sections/shared/ProviderDetailSectionTitle";
import ProviderDetailVisibilityToggle from "./sections/shared/ProviderDetailVisibilityToggle";

export default function ProviderDetailServicesSection(props) {
  const { permissionState } = props;
  const section = useProviderDetailServicesSection(props);
  const canManage = permissionState.canManageProviderServices;

  return (
    <ProviderDetailSectionCard>
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between gap-4">
          <ProviderDetailSectionTitle>Services Provided</ProviderDetailSectionTitle>
          <ProviderDetailVisibilityToggle
            isVisible={section.isVisible}
            onToggle={() => section.setIsVisible((prev) => !prev)}
            sectionName="services provided"
            toggleId="toggle-services-provided-visibility"
          />
        </div>

        <Collapse in={section.isVisible} timeout={250} unmountOnExit>
          {canManage ? (
            <>
              <div className="flex min-h-0 flex-row gap-3">
                <ServicesPanel
                  currentPage={section.availablePage}
                  data={section.availableServicesDisplay}
                  loading={section.loadingState.available}
                  onPageChange={(_, page) => section.setAvailablePage(page)}
                  onSearchChange={section.setAvailableSearch}
                  onSelectAll={(checked) => section.setSelectedAvailableServices(checked ? [...section.availableServicesDisplay] : [])}
                  onToggleRow={(checked, item) => section.setSelectedAvailableServices((prev) => checked ? [...prev, item] : prev.filter((service) => service.id !== item.id))}
                  resetCurrentPage={() => section.setAvailablePage(1)}
                  resultCount={section.availableResultCount}
                  searchText={section.availableSearch}
                  selectedServices={section.selectedAvailableServices}
                  title={STRINGS.HEADERS.AVAILABLE_SERVICES}
                />
                {section.hasActiveSelection ? (
                  <div className="flex h-[420px] flex-col items-center justify-center gap-2">
                    <LeftNavigation disabled={!permissionState.canDeleteProviderServices || !section.selectedProvidedServices.length} handleOnClick={section.moveLeft} />
                    <RightNavigation disabled={!permissionState.canAddProviderServices || !section.selectedAvailableServices.length} handleOnClick={section.moveRight} />
                  </div>
                ) : null}
                <ServicesPanel
                  currentPage={section.providedPage}
                  data={section.providedServicesDisplay}
                  loading={section.loadingState.provided}
                  onPageChange={(_, page) => section.setProvidedPage(page)}
                  onSearchChange={section.setProvidedSearch}
                  onSelectAll={(checked) => section.setSelectedProvidedServices(checked ? [...section.providedServicesDisplay.filter((item) => item.serviceType !== STRINGS.SERVICE_TYPE.AVAILABLE)] : [])}
                  onToggleRow={(checked, item) => section.setSelectedProvidedServices((prev) => checked ? [...prev, item] : prev.filter((service) => service.id !== item.id))}
                  resetCurrentPage={() => section.setProvidedPage(1)}
                  resultCount={section.providedResultCount}
                  searchText={section.providedSearch}
                  selectedServices={section.selectedProvidedServices}
                  showAddedState
                  title={STRINGS.HEADERS.PROVIDED_SERVICES}
                />
              </div>
              {section.hasActiveSelection || section.hasPendingChanges ? (
                <div className="flex w-full flex-row justify-end">
                  <div className="flex w-full gap-2 py-2 md:w-1/2 md:justify-end">
                    <CancelButton disabled={section.loadingState.saving} onClick={section.resetSelection} />
                    <SaveButton disabled={!section.hasPendingChanges || section.loadingState.saving} onClick={section.saveChanges} label={STRINGS.BUTTON_LABELS.SAVE} />
                  </div>
                </div>
              ) : null}
            </>
          ) : (
            <div className="rounded-[14px] p-4">
              <ServicesPanel
                currentPage={section.providedPage}
                data={section.providedServicesDisplay}
                loading={section.loadingState.provided}
                onPageChange={(_, page) => section.setProvidedPage(page)}
                onSearchChange={section.setProvidedSearch}
                onSelectAll={() => {}}
                onToggleRow={() => {}}
                readOnly
                resetCurrentPage={() => section.setProvidedPage(1)}
                resultCount={section.providedResultCount}
                searchText={section.providedSearch}
                selectedServices={[]}
                title={STRINGS.HEADERS.PROVIDED_SERVICES}
              />
            </div>
          )}
        </Collapse>
      </div>
    </ProviderDetailSectionCard>
  );
}

ProviderDetailServicesSection.propTypes = {
  permissionState: PropTypes.object.isRequired,
  providerInformation: PropTypes.object.isRequired,
};
